import {
  ApolloGrade,
  PlayerLevel,
  PlayerPosition,
  PlayerRole,
  FreeAgencyType,
  ScoreKey,
} from "@suns/api";

type LabelInput =
  | keyof typeof ApolloGrade
  | keyof typeof PlayerRole
  | keyof typeof PlayerPosition
  | keyof typeof PlayerLevel
  | keyof typeof FreeAgencyType
  | keyof typeof ScoreKey;

const labels: Record<LabelInput, string> = {
  [ApolloGrade.FRANCHISE]: "Franchise",
  [ApolloGrade.ALL_STAR]: "All Star",
  [ApolloGrade.ALL_STAR_PLUS]: "All Star Plus",
  [ApolloGrade.STARTER]: "Starter",
  [ApolloGrade.TOP_ROTATION]: "Top Rotation",
  [ApolloGrade.ROTATION]: "Rotation",
  [ApolloGrade.ROSTER]: "Roster",
  [ApolloGrade.MINOR_LEAGUE]: "Minor League",
  [PlayerPosition.POINT_GUARD]: "Point Guard (PG)",
  [PlayerPosition.GUARD]: "Guard (G)",
  [PlayerPosition.WING]: "Wing (W)",
  [PlayerPosition.FORWARD]: "Forward (F)",
  [PlayerPosition.BIG]: "Big (B)",
  [PlayerRole.PLAYMAKER]: "Playmaker (PM)",
  [PlayerRole.SHOOTER]: "Shooter (SH)",
  [PlayerRole.PERIMETER_SCORER]: "Perimeter Scorer (PS)",
  [PlayerRole.SLASHER_DRIVER]: "Slasher/Driver (SD)",
  [PlayerRole.INTERIOR_FINISHER]: "Interior Finisher (IF)",
  [PlayerRole.PERIMETER_DEFENDER]: "Perimeter Defender (PD)",
  [PlayerRole.INTERIOR_DEFENDER]: "Interior Defender (ID)",
  [PlayerLevel.PRO]: "Pro",
  [PlayerLevel.AMATEUR]: "Amateur",
  [FreeAgencyType.RFA]: "Restricted Free Agent",
  [FreeAgencyType.UFA]: "Unrestricted Free Agent",
  [FreeAgencyType.TO]: "Trade Option",
  [FreeAgencyType.PO]: "Player Option",
  [ScoreKey.SCORING]: "Scorer",
  [ScoreKey.PASSING]: "Passing",
  [ScoreKey.PR_PLAYMAKING]: "P/R Playmaking",
  [ScoreKey.FINISHING]: "Finishing",
  [ScoreKey.OFFENSIVE_REBOUNDING]: "Offensive Rebounding",
  [ScoreKey.PR_SCREENING]: "P/R Screening",
  [ScoreKey.CS_SHOOTING]: "C&S Shooting",
  [ScoreKey.MOVEMENT_SHOOTING]: "Movement Shooting",
  [ScoreKey.OFF_DRIBBLE_SHOOTING]: "Off-Dribble Shooting",
  [ScoreKey.ON_BALL_DEFENSE]: "On-ball",
  [ScoreKey.PR_DEFENSE]: "Pick and Roll",
  [ScoreKey.DEFENSIVE_VERSATILITY]: "Versatility",
  [ScoreKey.OFF_BALL_DEFENSE]: "Off-ball",
  [ScoreKey.DEFENSIVE_REBOUNDING]: "Rebounding",
  [ScoreKey.RIM_PROTECTION]: "Rim Protection",
  [ScoreKey.BASKETBALL_IQ]: "Basketball IQ",
  [ScoreKey.VERTICAL_ATHLETICISM]: "Vertical Athleticism",
  [ScoreKey.AGILITY]: "Agility",
  [ScoreKey.DEFEND_POINT_GUARD]: "Point Guard",
  [ScoreKey.DEFEND_GUARD]: "Guard",
  [ScoreKey.DEFEND_WING]: "Wing",
  [ScoreKey.DEFEND_FORWARD]: "Forward",
  [ScoreKey.DEFEND_BIG]: "Big",
};

export function getLabel(input: LabelInput) {
  return labels[input] || input;
}

export function getAcronym(input: LabelInput) {
  return getLabel(input)
    .split(" ")
    .map((word) => word[0])
    .join("");
}
